import { render, staticRenderFns } from "./ClubSignDetail.vue?vue&type=template&id=1b1927a8&scoped=true&"
import script from "./ClubSignDetail.vue?vue&type=script&lang=ts&"
export * from "./ClubSignDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ClubSignDetail.vue?vue&type=style&index=0&id=1b1927a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1927a8",
  null
  
)

export default component.exports